const MultiSelectDropdown = ({ options, selectedOptions, onChange }) => {
    const handleCheckboxChange = (event) => {
        const { value } = event.target;
      
        // If the clicked value is already selected, unselect it
        if (selectedOptions.includes(value)) {
          onChange([]); // Clear selection
        } else {
          onChange([value]); // Replace with new single selection
        }
      };
  
    return (
      <div className="custom-multi-select dropdown">
        <button
          className="btn btn-primary dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{"fontSize":"13px","padding":"6px 14px"}}
        >
          Select Users
        </button>
        <ul className="dropdown-menu">
          {options.map((option) => (
            <li key={option.value} className="dropdown-item">
              <label>
                <input
                  type="checkbox"
                  value={option.value}
                  checked={selectedOptions.includes(option.value.toString())}
                  onChange={handleCheckboxChange} // Trigger change handler
                />
                {` ${option.label}`}
              </label>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  

export default MultiSelectDropdown;
